import React from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import moment from "moment";
class DriverRoutes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { drivers, routes, timeslots } = this.props;
    return (
      <div className="container-fluid">
        <div className="d-flex flex-row justify-content-around">
          <h4 className="p-6">
            <span className="text-secondary">{routes.length} routes </span>
          </h4>
        </div>
        <br></br>
        <Table striped bordered hover responsive>
          <thead>
            <tr className="table-primary">
              <th>Id</th>
              <th>Date</th>
              <th>Timeslot</th>
              <th>Driver</th>
              <th>Count</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {routes.map((route, i) => {
              const driver = drivers.find(
                (driv) => driv.id === routes[i].driver_id
              );
              routes[i].booking_ids.sort();

              const first_slot = timeslots.find(
                (slot) => slot.id == route.booking_ids[0]
              );
              const last_slot = timeslots.find(
                (slot) =>
                  slot.id ===
                  routes[i].booking_ids[routes[i].booking_ids.length - 1]
              );
              return (
                <tr
                  key={routes[i].id}
                  className={
                    routes[i].id % 2 == 0 ? "table-info" : "table-primary"
                  }
                >
                  <td>
                    <Link to={`/routes/${routes[i].id}`}>{routes[i].id}</Link>
                  </td>
                  <td>{routes[i].date}</td>
                  <td>
                    {first_slot &&
                      (routes[i].booking_ids.length == 1
                        ? first_slot.delivery_window
                        : `${first_slot.delivery_window.split("-")[0]}-${
                            last_slot.delivery_window.split("-")[1]
                          }`)}
                  </td>
                  <td>{routes[i].driver_id ? driver.first_name : ""}</td>
                  <td>{routes[i].delivery_ids.length}</td>
                  <td>
                    {routes[i].complete ? (
                      <span className="badge badge-pill badge-success">
                        Completed
                      </span>
                    ) : (
                      <span className="badge badge-pill badge-info">
                        Routed
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withRouter(DriverRoutes);
